module.exports = __webpack_public_path__ + "img/p13.b820a136.png";